import React, {Component} from 'react';
import {Row, Col, Card} from 'antd';
import VirtualMachineCard from './VirtualMachineCard.js';

class VirtualMachineCardList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vmData: this.props.vmData,
            loading: this.props.loading
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            vmData: nextProps.vmData,
            loading: nextProps.loading
        });
    }

    unPinVM = (hostName) => {
        this.props.unPinVM(hostName);
    }

    redirectToSystemUsage = (e) => {
        this.props.redirectToSystemUsage(e);
    }


    render() {
        const vmData = this.state.vmData;
        const loading = this.state.loading;
        var vmList = [];
        if (vmData && vmData.length > 0) {
            /*var vmArray = [];
            for (var i = 0; i < vmData.length / 3; i++) {
                var tmpArray = [];
                if (vmData[3 * i]) {
                    tmpArray[0] = vmData[3 * i];
                }
                if (vmData[3 * i + 1]) {
                    tmpArray[1] = vmData[3 * i + 1];
                }
                if (vmData[3 * i + 2]) {
                    tmpArray[2] = vmData[3 * i + 2];
                }
                vmArray.push(tmpArray);
            }
            vmList = vmArray.map((vm, index) => {
                var vmTemp = vm.map((virtualMachine, index1) =>
                    <Col span={8} key={index1}>
                        <Card bodyStyle={{padding: 10}}>
                            <VirtualMachineCard virtualMachine={virtualMachine}/>
                        </Card>
                    </Col>
                );
                <div key={index}>
                    {vmTemp}
                </div>
            });*/

            vmList = vmData.map((virtualMachine, index) =>
                <Col span={8} key={index} className="virtual-machine-col">
                    <VirtualMachineCard virtualMachine={virtualMachine} unPinVM={this.unPinVM}/>
                </Col>
            );
        }

        return (
            <div>
                <Card loading style={{height: 215, display: loading ? 'block' : 'none'}}/>
                <div className="virtual-machine-list" style={{display: !loading && (vmData && vmData.length > 0) ? 'block' : 'none'}}>
                    <Row>
                        {vmList}
                    </Row>
                </div>
                <Card className="no-virtual-machine" style={{display: !loading && (vmData && vmData.length === 0) ? 'block' : 'none'}}>
                    <br/><br/><br/>
                    <div className="no-virtual-machine-content">
                        No virtual machine pinned.
                    </div>
                    <div className="no-virtual-machine-action">
                        You could pin virtual machine in <a href="#" onClick={this.redirectToSystemUsage}>system usage</a> page.
                    </div>
                </Card>
            </div>

        );
    }
}

export default VirtualMachineCardList;


// WEBPACK FOOTER //
// ./src/modules/dashboard/VirtualMachineCardList.js